// extracted by mini-css-extract-plugin
export var articleContent = "article-module--article-content--fbJeD";
export var main = "article-module--main--hB026";
export var mainAuthor = "article-module--main-author--9lkoI";
export var mainContainer = "article-module--main-container--aqHt1";
export var mainDate = "article-module--main-date--J5Tn9";
export var mainImage = "article-module--main-image--VY6Cm";
export var mainInfo = "article-module--main-info--HVrAJ";
export var mainSubtitle = "article-module--main-subtitle--luJ7r";
export var mainTitle = "article-module--main-title--jNFS7";